import { useEffect, useRef } from "react";

export function usePrevious<T>(value: T) {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
}
